import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DownloadLinkListComponent } from './download-link-list.component';
import { DownloadLinkModule } from '../download-link/download-link.module';

@NgModule({
  declarations: [DownloadLinkListComponent],
  imports: [
    CommonModule,
    DownloadLinkModule,
  ],
  exports: [DownloadLinkListComponent],
})
export class DownloadLinkListModule {}
